var _path, _rect, _path2, _path3, _rect2, _rect3, _g, _path4, _path5, _path6, _path7, _path8, _rect4, _rect5, _path9, _path10, _rect6, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModalBanerMainnet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281,
    height: 491,
    viewBox: "0 0 281 491",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_101_3",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 281,
    height: 491
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0917969 0.362305H256.334C269.455 0.362305 280.092 10.9989 280.092 24.1199V467.226C280.092 480.347 269.455 490.983 256.334 490.983H0.0917969V0.362305Z",
    fill: "url(#paint0_linear_101_3)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_101_3)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 367.418,
    height: 512.899,
    transform: "matrix(1 0 0 -1 0.101654 491.243)",
    fill: "url(#paint1_radial_101_3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.192 58.9498C346.774 61.7889 346.777 66.4908 344.275 69.358L262.825 162.724C260.323 165.591 256.273 165.526 253.602 162.8C240.301 149.22 224.063 139.993 206.605 136.171C187.036 131.888 166.868 134.603 148.808 143.952C144.573 146.145 140.501 148.677 136.619 151.524C122.819 159.172 109.406 169.983 97.2508 182.779C76.3006 204.835 57.4196 234.488 45.1395 269.479C27.4644 319.843 23.5292 381.162 46.4452 446.465C34.6983 435.192 23.8939 422.536 14.2269 408.647C-14.777 366.977 -32.156 316.208 -35.5795 263.147C-39.003 210.086 -28.3073 157.272 -4.92684 111.786C18.4537 66.3005 53.401 30.3187 95.2285 8.66617C137.056 -12.9863 183.764 -19.2742 229.088 -9.3541C272.303 0.104398 312.29 23.8664 344.192 58.9498ZM116.897 492.592C120.132 493.904 123.397 495.134 126.69 496.28C170.907 511.665 217.985 511.121 261.611 494.722C303.207 479.086 339.768 449.748 366.866 410.367C369.059 407.18 368.458 402.522 365.611 400.044L272.931 319.362C270.085 316.884 266.08 317.536 263.785 320.624C252.353 336.005 237.452 347.501 220.648 353.818C201.811 360.899 181.484 361.133 162.393 354.491C143.301 347.848 126.357 334.645 113.834 316.653C103.597 301.946 96.7142 284.613 93.7349 266.26C90.9932 272.219 88.468 278.433 86.2054 284.88C66.6336 340.648 66.5786 414.105 116.897 492.592Z",
    fill: "#F8FEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.439 259.922C191.156 260.718 192.109 261.236 193.174 261.314C194.365 261.4 195.467 260.917 196.284 260.068L193.421 263.824L190.405 259.923L190.439 259.922Z",
    fill: "#2C94F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_101_3",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -63,
    y: -27,
    width: 476,
    height: 545
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -66.7936,
    y: -12.3793,
    width: 462.956,
    height: 534.897,
    rx: 120.387,
    transform: "rotate(-2.27416 -66.7936 -12.3793)",
    fill: "#2AACFA"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_101_3)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -66.7947,
    y: -12.3793,
    width: 462.956,
    height: 534.897,
    rx: 120.387,
    transform: "rotate(-2.27416 -66.7947 -12.3793)",
    fill: "url(#paint2_linear_101_3)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter0_d_101_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.2563 340.79C23.4964 235.454 -38.6887 289.376 -120.274 305.282C12.0504 -604.542 280.13 -108.93 446.95 157.379C573.879 360.007 550.655 443.352 383.269 501.092C255.639 545.118 154.428 436.034 92.2563 340.79Z",
    fill: "url(#paint3_linear_101_3)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_101_3)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.251 272.438C41.5029 135.987 -35.7298 159.455 -107.283 161.104C-99.2141 -517.684 346.98 -62.1533 437.012 44.8147C591.849 228.78 487.95 359.37 439.285 394.369C400.428 422.314 311.818 421.928 247.57 377.062C204.949 353.251 175.637 319.478 141.251 272.438Z",
    fill: "url(#paint4_linear_101_3)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-81.8733 159.316C-90.2439 159.805 -98.504 160.287 -106.675 160.49C-104.594 -8.79997 -75.2104 -107.234 -31.0405 -158.078C-8.94472 -183.513 16.859 -197.049 44.8388 -201.598C72.8323 -206.15 103.041 -201.712 133.934 -191.131C195.73 -169.966 260.127 -124.269 314.726 -77.1425C369.316 -30.0243 414.062 18.4793 436.553 45.201C513.875 137.069 526.533 215.525 513.875 275.33C501.209 335.172 463.173 376.45 438.935 393.882C419.661 407.743 387.952 414.628 352.987 412.421C318.04 410.215 279.935 398.932 247.914 376.57L247.889 376.553L247.863 376.538C205.36 352.793 176.11 319.108 141.735 272.084C91.8055 203.783 47.4555 175.433 6.56714 164.404C-24.68 155.976 -53.8933 157.682 -81.8733 159.316Z",
    stroke: "url(#paint5_linear_101_3)",
    strokeWidth: 1.19994,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_101_3)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M167.902 220.756C68.1546 84.3037 -42.4865 74.6508 -105.978 47.0431C-59.3362 -369.355 329.645 -113.055 419.676 -6.08704C574.513 177.878 500.707 278.766 421.95 343.467C362.273 392.493 259.077 345.479 167.902 220.756Z",
    fill: "url(#paint6_linear_101_3)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168.387 220.402C88.8553 111.605 2.32707 83.268 -61.6073 62.3302C-77.7895 57.0307 -92.5243 52.2052 -105.332 46.6691C-93.6372 -57.0794 -60.6535 -118.815 -16.4712 -151.486C27.7697 -184.201 83.3774 -187.876 140.448 -175.198C197.518 -162.521 255.971 -133.507 305.792 -100.966C355.614 -68.4242 396.757 -32.386 419.217 -5.70068C496.578 86.2132 516.722 157.255 507.819 213.32C498.912 269.402 460.916 310.679 421.569 343.003C391.974 367.316 351.528 367.883 306.995 346.726C262.459 325.567 213.938 282.714 168.387 220.402Z",
    stroke: "url(#paint7_linear_101_3)",
    strokeWidth: 1.19994,
    style: {
      mixBlendMode: "overlay"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M188.986 146.158C109.878 37.941 30.4947 2.12906 -27.5604 -24.0612C-42.6379 -30.8631 -56.2769 -37.016 -68.0989 -43.6198C-61.1081 -119.709 -32.6023 -164.791 7.46803 -188.006C47.639 -211.279 99.5728 -212.659 153.458 -201.028C207.332 -189.399 263.069 -164.783 310.763 -136.183C358.465 -107.58 398.07 -75.0241 419.709 -47.55C487.876 38.9995 510.014 104.165 503.065 158.62C496.115 213.083 460.049 257.012 411.345 301.048C397.801 313.294 382.889 317.527 366.701 315.087C350.477 312.642 332.925 303.486 314.172 288.846C276.667 259.567 234.573 208.52 188.986 146.158Z",
    fill: "url(#paint8_linear_101_3)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.986 146.158C109.878 37.941 30.4947 2.12906 -27.5604 -24.0612C-42.6379 -30.8631 -56.2769 -37.016 -68.0989 -43.6198C-61.1081 -119.709 -32.6023 -164.791 7.46803 -188.006C47.639 -211.279 99.5728 -212.659 153.458 -201.028C207.332 -189.399 263.069 -164.783 310.763 -136.183C358.465 -107.58 398.07 -75.0241 419.709 -47.55C487.876 38.9995 510.014 104.165 503.065 158.62C496.115 213.083 460.049 257.012 411.345 301.048C397.801 313.294 382.889 317.527 366.701 315.087C350.477 312.642 332.925 303.486 314.172 288.846C276.667 259.567 234.573 208.52 188.986 146.158Z",
    stroke: "url(#paint9_linear_101_3)",
    strokeWidth: 1.2,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_101_3)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M246.882 139.881C176.971 0.0834375 44.6787 -99.2763 -12.7284 -131.481C53.7337 -229.868 349.241 -218.803 428.414 -101.854C507.587 15.0953 476.484 166.768 408.201 247.785C383.558 270.066 316.794 279.679 246.882 139.881Z",
    fill: "url(#paint10_linear_101_3)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M247.419 139.613C177.667 0.133351 45.9078 -99.1082 -11.8645 -131.684C4.72456 -155.835 35.3265 -173.356 73.2704 -184.228C111.481 -195.177 157.055 -199.36 203.043 -196.819C249.03 -194.279 295.402 -185.017 335.208 -169.099C375.02 -153.179 408.215 -130.62 427.917 -101.517C506.902 15.1545 475.893 166.508 407.769 247.367C395.611 258.339 373.022 266.243 344.755 254.062C316.432 241.857 282.347 209.457 247.419 139.613Z",
    stroke: "url(#paint11_linear_101_3)",
    strokeWidth: 1.19994,
    style: {
      mixBlendMode: "overlay"
    }
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6992 459.3V426.84H51.6197V430.54H34.7071V441.022H49.5497V444.677H34.7071V459.3H30.6992ZM61.4038 459.3V455.6H65.3677V430.54H61.4038V426.84H73.3395V430.54H69.3757V455.6H73.3395V459.3H61.4038ZM86.2676 459.3V426.84H91.729L106.219 452.958V426.84H110.227V459.3H105.47L91.2445 433.667H90.2755V459.3H86.2676ZM121.052 459.3L132.018 426.84H138.229L149.195 459.3H145.011L142.237 450.844H128.011L125.28 459.3H121.052ZM129.2 447.32H141.091L135.63 430.628H134.617L129.2 447.32ZM160.03 459.3V426.84H165.491L179.981 452.958V426.84H183.989V459.3H179.232L165.006 433.667H164.038V459.3H160.03ZM201.817 459.3L197.192 454.675V431.465L201.817 426.84H216.483L220.975 431.332L218.421 433.931L214.897 430.407H203.622L201.2 432.83V453.31L203.622 455.732H215.25L218.817 452.165L221.372 454.763L216.791 459.3H201.817ZM232.931 459.3V426.84H254.336V430.54H236.939V440.405H252.487V444.061H236.939V455.6H254.336V459.3H232.931Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 96.4302,
    y: 380.659,
    width: 3.64381,
    height: 22.2618,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 66.81,
    y: 386.303,
    width: 3.64381,
    height: 16.9699,
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M130.482 403.569C129.643 403.515 128.83 403.348 128.045 403.069C127.27 402.778 126.582 402.385 125.979 401.89C125.377 401.395 124.914 400.804 124.591 400.115L127.916 398.695C128.045 398.91 128.255 399.141 128.545 399.389C128.836 399.626 129.18 399.825 129.578 399.986C129.987 400.147 130.433 400.228 130.918 400.228C131.326 400.228 131.714 400.174 132.08 400.067C132.456 399.948 132.757 399.771 132.983 399.534C133.22 399.297 133.338 398.991 133.338 398.614C133.338 398.216 133.199 397.909 132.919 397.694C132.65 397.468 132.306 397.302 131.886 397.194C131.477 397.076 131.079 396.968 130.692 396.871C129.67 396.667 128.717 396.349 127.835 395.919C126.964 395.489 126.259 394.935 125.721 394.257C125.194 393.568 124.93 392.74 124.93 391.771C124.93 390.706 125.21 389.786 125.769 389.012C126.329 388.237 127.066 387.64 127.98 387.22C128.895 386.801 129.879 386.591 130.934 386.591C132.214 386.591 133.387 386.86 134.452 387.398C135.528 387.925 136.378 388.673 137.002 389.641L133.887 391.481C133.737 391.223 133.527 390.986 133.258 390.771C132.989 390.545 132.682 390.362 132.338 390.222C131.994 390.071 131.633 389.985 131.257 389.964C130.772 389.942 130.331 389.985 129.933 390.093C129.535 390.2 129.212 390.383 128.965 390.642C128.728 390.9 128.61 391.244 128.61 391.674C128.61 392.083 128.771 392.39 129.094 392.594C129.417 392.788 129.804 392.939 130.256 393.046C130.719 393.154 131.16 393.272 131.579 393.401C132.526 393.713 133.414 394.095 134.242 394.547C135.081 394.999 135.754 395.553 136.26 396.21C136.765 396.866 137.007 397.651 136.986 398.566C136.986 399.609 136.674 400.524 136.05 401.309C135.426 402.084 134.619 402.676 133.629 403.085C132.65 403.494 131.601 403.655 130.482 403.569Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4273 394.791C92.4273 399.477 88.6284 403.276 83.9423 403.276C79.2562 403.276 75.4573 399.477 75.4573 394.791C75.4573 390.105 79.2562 386.306 83.9423 386.306C88.6284 386.306 92.4273 390.105 92.4273 394.791ZM79.0957 394.791C79.0957 397.468 81.2656 399.637 83.9423 399.637C86.619 399.637 88.7889 397.468 88.7889 394.791C88.7889 392.114 86.619 389.944 83.9423 389.944C81.2656 389.944 79.0957 392.114 79.0957 394.791Z",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 75.4573,
    y: 380.659,
    width: 3.64324,
    height: 22.6159,
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4531 394.788C70.4531 399.475 66.6542 403.273 61.9681 403.273C57.282 403.273 53.4831 399.475 53.4831 394.788C53.4831 390.102 57.282 386.303 61.9681 386.303C66.6542 386.303 70.4531 390.102 70.4531 394.788ZM57.1218 394.788C57.1218 397.465 59.2916 399.635 61.9681 399.635C64.6446 399.635 66.8144 397.465 66.8144 394.788C66.8144 392.112 64.6446 389.942 61.9681 389.942C59.2916 389.942 57.1218 392.112 57.1218 394.788Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6245 383.658C49.0492 381.652 46.8962 380.177 44.4561 379.433C42.0161 378.689 39.4064 378.711 36.9795 379.497C34.5526 380.283 32.4253 381.795 30.8847 383.828C29.3442 385.862 28.4646 388.319 28.3647 390.868C28.2648 393.417 28.9494 395.935 30.3261 398.083C31.7028 400.23 33.7053 401.904 36.0632 402.877C38.4212 403.851 41.0211 404.077 43.5119 403.527C46.0027 402.976 48.2645 401.674 49.992 399.797L47.2593 397.282C46.0465 398.6 44.4586 399.514 42.7099 399.9C40.9612 400.287 39.1359 400.128 37.4805 399.445C35.8251 398.761 34.4192 397.586 33.4527 396.078C32.4862 394.571 32.0055 392.803 32.0757 391.013C32.1458 389.223 32.7633 387.498 33.8449 386.071C34.9264 384.643 36.4199 383.582 38.1238 383.03C39.8276 382.479 41.6597 382.463 43.3728 382.985C45.0859 383.508 46.5974 384.543 47.7033 385.952L50.6245 383.658Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.075 396.325C121.176 395.799 121.228 395.256 121.228 394.701C121.228 389.965 117.389 386.126 112.653 386.126C107.917 386.126 104.077 389.965 104.077 394.701C104.077 399.437 107.917 403.277 112.653 403.277C115.949 403.277 118.811 401.417 120.247 398.69L116.354 397.783C115.471 398.843 114.141 399.517 112.653 399.517C110.563 399.517 108.783 398.186 108.117 396.325H121.075ZM117.253 393.27C116.643 391.309 114.814 389.885 112.653 389.885C110.492 389.885 108.662 391.309 108.053 393.27H117.253Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_101_3",
    x: -166.387,
    y: -262.012,
    width: 740.381,
    height: 822.159,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.88204
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.0563
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.02125 0 0 0 0 0.0616251 0 0 0 0 0.425 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_101_3",
    x: -129.618,
    y: -223.43,
    width: 670.692,
    height: 662.074,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.88204
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.1679
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0425347 0 0 0 0 0.0525 0 0 0 0 0.291667 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_101_3",
    x: -143.444,
    y: -217.144,
    width: 691.285,
    height: 620.046,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.88204
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.7332
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00616318 0 0 0 0 0.122031 0 0 0 0 0.295833 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_101_3",
    x: -42.2692,
    y: -224.798,
    width: 547.042,
    height: 518.024,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.88204
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.7704
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.290196 0 0 0 0 0.333333 0 0 0 0 0.890196 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_3",
    x1: 6.0918,
    y1: -25.0166,
    x2: 232.092,
    y2: 236.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#319FF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555FD2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_101_3",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-85.5384 -173.629) rotate(60.9576) scale(898.451 870.298)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F3DC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177023,
    stopColor: "#2AACFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431754,
    stopColor: "#205BED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629073,
    stopColor: "#1C46AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864583,
    stopColor: "#172A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171A51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_101_3",
    x1: 155.207,
    y1: 186.708,
    x2: -246.201,
    y2: 689.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5361E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.20088,
    stopColor: "#5F5BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F2885"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_101_3",
    x1: 194.324,
    y1: 63.4786,
    x2: 16.0804,
    y2: 775.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#486AE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8046D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_101_3",
    x1: 67.8062,
    y1: 2.04684,
    x2: 36.7612,
    y2: 810.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E72E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#754DDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_101_3",
    x1: 16.3334,
    y1: 166.5,
    x2: 354.13,
    y2: 429.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_101_3",
    x1: 95.659,
    y1: 57.7875,
    x2: 517.758,
    y2: 560.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#367CE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D6CDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_101_3",
    x1: 43.0337,
    y1: 66.7748,
    x2: 344.981,
    y2: 371.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_101_3",
    x1: 176.119,
    y1: 34.9125,
    x2: 613.553,
    y2: 454.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2094EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#476DE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_101_3",
    x1: 175.824,
    y1: 85.1776,
    x2: 331.568,
    y2: 320.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_101_3",
    x1: 240.783,
    y1: -85.3021,
    x2: 337.385,
    y2: 298.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CCF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3994EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_101_3",
    x1: 211.472,
    y1: 63.4327,
    x2: 317.324,
    y2: 235.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalBanerMainnet);
export default __webpack_public_path__ + "static/media/modal-baner-mainnet.d42ca7c535b0841c9e9ce78b9c9439d9.svg";
export { ForwardRef as ReactComponent };